import { createSlice } from "@reduxjs/toolkit";

//STATE
const initialState = {
  rows: [],
  isLoading: false,
  currentItem: {},
};

//STORE SLICE
export const bidItemSlice = createSlice({
  name: "bidItemSlice",
  initialState,
  //REDUCER
  reducers: {
    // setBidsList(state, action) {
    //   return {
    //     ...state,
    //     rows: action.payload,
    //   };
    // },
    showLoading(state) {
      return {
        ...state,
        isLoading: true,
      };
    },
    hideLoading(state) {
      return {
        ...state,
        isLoading: false,
      };
    },
    // addBid(state, action) {
    //   return {
    //     ...state,
    //     rows: [...state.rows, action.payload],
    //   };
    // },
    // editBid(state, action) {
    //   return {
    //     ...state,
    //     rows: state.rows.map((row) =>
    //       row.id === action.payload.id ? action.payload : row
    //     ),
    //   };
    // },
    // deleteBid(state, action) {
    //   return {
    //     ...state,
    //     rows: state.rows.filter((row) => row.id !== action.payload),
    //   };
    // },
    setCurrentItem(state, action) {
      return {
        ...state,
        currentItem: action.payload,
      };
    },
  },
});

//ACTIONS
export const {
    // setBidsList,
    showLoading,
    hideLoading,
    // addBid,
    // editBid,
    // deleteBid,
    setCurrentItem,
} = bidItemSlice.actions;

export default bidItemSlice.reducer;
